"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i={mb:"72px"},a=n=>({mb:n?"112px":"72px"});exports.navigationSpacing=i;exports.navigationSpacingDesktop=a;
